import AxiosInstance from "../../AxiosInstance";

const baseUrlApiOPBill = '/ob/billing'
const AcountsServices = {

    getAccountLedgerType:()=>{
        return AxiosInstance.get(baseUrlApiOPBill+'/getAccountLedgerType');
    },
    getAccountHead:()=>{
        return AxiosInstance.get(baseUrlApiOPBill+'/getAccountHead');
    },
    insertAccountHead:(details)=>{
        return AxiosInstance.post(baseUrlApiOPBill+'/insertAccountHead',details);
    },
    updateAccountHead:(details)=>{
        return AxiosInstance.put(baseUrlApiOPBill+'/updateAccountHead',details);
    },
    deleteAccountHead:(headName)=>{
        return AxiosInstance.delete(baseUrlApiOPBill+'/deleteAccountHead?headName='+headName);
    },

    //billpaidByy

    getBillPaidBy:()=>{
        return AxiosInstance.get(baseUrlApiOPBill+'/getBillPaidBy')
    },
    insertBillPaidBy:(details)=>{
        return AxiosInstance.post(baseUrlApiOPBill+'/insertBillPaidBy',details);
    },
    updateBillPaidBy:(details)=>{
        return AxiosInstance.put(baseUrlApiOPBill+'/updateBillPaidBy',details);
    },
    deleteBillPaidBy:(billPaidBy)=>{
        return AxiosInstance.delete(baseUrlApiOPBill+'/deleteBillPaidBy?billPaidBy='+billPaidBy);
    },
  
    //billPaidTo
    getBillPaidTo:()=>{
        return AxiosInstance.get(baseUrlApiOPBill+'/getBillPaidTo')
    },

    insertBillPaidTo:(details)=>{
        return AxiosInstance.post(baseUrlApiOPBill+'/insertBillPaidTo',details);
    },
    updateBillPaidTo:(details)=>{
        return AxiosInstance.put(baseUrlApiOPBill+'/updateBillPaidTo',details);
    },
    deleteBillPaidTo:(billPaidTo)=>{
        return AxiosInstance.delete(baseUrlApiOPBill+'/deleteBillPaidTo?billPaidTo='+billPaidTo);
    },

    //paymentType
    getBillPaymentType:()=>{
        return AxiosInstance.get(baseUrlApiOPBill+'/getBillPaymentType')
    },
    insertPaymentType:(details)=>{
        return AxiosInstance.post(baseUrlApiOPBill+'/insertPaymentType',details);
    },
    updatePaymentType:(details)=>{
        return AxiosInstance.put(baseUrlApiOPBill+'/updatePaymentType',details);
    },
    deletePaymentType:(paymentType)=>{
        return AxiosInstance.delete(baseUrlApiOPBill+'/deletePaymentType?paymentType='+paymentType);
    },

    //PrintedType
    getPrintedType:()=>{
        return AxiosInstance.get(baseUrlApiOPBill+'/getPrintedType');
    },

    insertPrintedType:(details)=>{
        return AxiosInstance.post(baseUrlApiOPBill+'/insertPrintedType',details);
    },
    updatePrintedType:(details)=>{
        return AxiosInstance.put(baseUrlApiOPBill+'/updatePrintedType',details);
    },
    deletePrintedType:(printedType)=>{
        return AxiosInstance.delete(baseUrlApiOPBill+'/deletePrintedType?printedType='+printedType);
    },
    //vocherTyype
    getVoucherType:()=>{
        return AxiosInstance.get(baseUrlApiOPBill+'/getVoucherType');
    },
    insertVoucherType:(details)=>{
        return AxiosInstance.post(baseUrlApiOPBill+'/insertVoucherType',details);
    },
    updateVoucherType:(details)=>{
        return AxiosInstance.put(baseUrlApiOPBill+'/updateVoucherType',details);
    },
    deleteVoucherType:(voucherType)=>{
        return AxiosInstance.delete(baseUrlApiOPBill+'/deleteVoucherType?voucherType='+voucherType);
    },

}
export default AcountsServices;